
export interface IAccountRoles {
    owner: boolean;
    admin: boolean;
    editor: boolean;
    viewer: boolean;
    any: boolean;
}

export const emptyAccountRoles = { owner: false, admin: false, editor: false, viewer: false, any: false };

interface IAccountChitInfo {
    nextTerm: number;
    chit_tenure: number;
}

export interface IAccount {
    _id: string;
    name: string;
    desc: string;
    type: string;
    curr: string;
    status: string;
    chit_info: IAccountChitInfo;
    isOwner: boolean;
    isAdmin: boolean;
    isEditor: boolean;
    isViewer: boolean;
}

export const emptyAccount: IAccount = {
    _id: "default",
    name: "unknown",
    desc: "",
    type: "",
    curr: "",
    status: "",
    chit_info: {
        nextTerm: 0,
        chit_tenure: 0
    },
    isOwner: false,
    isAdmin: false,
    isEditor: false,
    isViewer: false,
}